<h2 mat-dialog-title>One Step Verification Process</h2>
<mat-dialog-content>
  <div>
    <p class="text-center">
      You will be redirected to CDSL website to verify your transaction.<br />
      Use TPIN sent on your SMS and email by CDSL.
    </p>

    <div class="padding flex-centered-container-hr">
      <button mat-raised-button class='margin-hr' (click)="regenerateTPIN()">Regenerate TPIN</button>
      <button mat-flat-button color='accent' class='margin-hr' [disabled]="isProceedLoading" (click)="proceedToCDSL()">
        <span *ngIf="!isProceedLoading">Proceed</span>
        <mat-spinner class="display-inline-flex" *ngIf="isProceedLoading" diameter="20"></mat-spinner>
      </button>
    </div>

    <div class="expandable">
      <p class="font-14 text-center font-bold cursor-pointer" (click)="toggleText()">
        Know about CDSL E-DIS
        <span>
          <mat-icon class='position-relative expand-icon'>
            <span *ngIf="!openTextBool">expand_more</span>
            <span *ngIf="openTextBool">expand_less</span>
          </mat-icon>
        </span>
      </p>
      <div class="content" *ngIf="openTextBool">
        <ul *ngFor="let point of extendedPoints">
          <li>
            {{point}}
          </li>
        </ul>
      </div>
    </div>
  </div>
</mat-dialog-content>